<template>
  <TheMenuLayout>
    <v-row>
      <v-col cols="12">
        <input accept="image/*" type="file" ref="avatar" class="d-none" @change="onFileChange">
        <div @click="changeAvatar" class="mb-2 text-center">
          <v-avatar size="80" :color="student.picture_url ? 'transparent' : 'grey'">
            <v-img
              v-if="student.picture_url"
              :src="student.picture_url"
              contain
            />
            <span
              v-else-if="student.firstname && student.lastname"
              class="white--text headline font-weight-bold"
            >
              {{student.firstname[0]}}{{student.lastname[0]}}
            </span>
          </v-avatar>
          <div class="text-subtitle-2">
            <a href="#">
              Changer ma photo
            </a>
          </div>
        </div>
      </v-col>
      <v-col cols="12">
        <BaseSectionHeader class="mt-4 mb-4">{{ $t('My profile') }}</BaseSectionHeader>
        <BaseParagraph class="mb-10">
          <strong>Section</strong> : {{ student.faculty?.name }}
          <br><br>
          <strong>Groupe</strong> : {{ student.group?.name }}
          <br><br>
          <strong>{{ $t('Firstname') }}</strong> : {{ student.firstname }}
          <br><br>
          <strong>{{ $t('Lastname') }}</strong> : {{ student.lastname }}
          <br><br>
          <strong>{{ $t('Address') }}</strong> : {{ student.address }}
          <br><br>
          <div v-if="student.address_2">
            <strong>{{ $t('Address 2') }}</strong> : {{ student.address_2 }}
            <br><br>
          </div>
          <strong>{{`${$t('Postal code')} - ${$t('City')}` }}</strong> : {{ `${student.postal_code} ${student.city}` }}
          <template v-if="student.minor">
            <br><br>
            <strong>{{ $t('Minor') }}</strong> : {{ student.minor }}
          </template>
          <template v-if="student.major">
            <br><br>
            <strong>{{ $t('Major') }}</strong> : {{ student.major }}
          </template>
        </BaseParagraph>

        <BaseSectionHeader class="mb-2">{{ $t('Change my password') }}</BaseSectionHeader>
        <form @submit="changePassword">
          <BasePasswordField v-model="currentPassword" :label="$t('Current password')" />
          <BasePasswordField v-model="password" :label="$t('New password')" class="mb-2" />
          <v-btn @click="changePassword" color="primary" block>
            {{ $t('Change my password' )}}
          </v-btn>
        </form>
      </v-col>
    </v-row>
  </TheMenuLayout>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import { mapFields } from 'vuex-map-fields';
import TheMenuLayout from '@/components/TheMenuLayout.vue';
import BaseSectionHeader from '@/components/BaseSectionHeader.vue';
import BaseParagraph from '@/components/BaseParagraph.vue';
import BasePasswordField from '@/components/BasePasswordField.vue';

export default {
  name: 'Profile',
  components: {
    TheMenuLayout,
    BaseSectionHeader,
    BaseParagraph,
    BasePasswordField,
  },
  computed: {
    ...mapState('authentication', ['student']),
    ...mapFields('authentication', ['form.password', 'form.currentPassword']),
  },
  methods: {
    ...mapActions('authentication', ['fetchMe', 'changePassword', 'uploadPicture']),
    changeAvatar() {
      this.$refs.avatar.click();
    },
    onFileChange(event) {
      const file = event.target.files[0];
      this.uploadPicture(file);
    },
  },
  created() {
    this.fetchMe();
  },
};
</script>
